export default (() => {
  const walkableProps = 'id\n'
+ 'elementType\n';

  const plugin = 'manifest {'
+ 'configurationSchema\n'
+ 'pluginId\n'
+ 'name\n'
+ 'description\n'
+ 'version\n'
+ '}\n'
+ 'entryPoints {'
+ 'entryPointData\n'
+ 'entryPointPath\n'
+ 'contentType\n'
+ 'context\n'
+ '}\n';

  const components = 'components {'
+ 'id\n'
+ 'config\n'
+ 'assets {'
+ 'edges {'
+ 'node {'
+ 'urn\n'
+ 'source\n'
+ 'metadata\n'
+ 'asset {'
+ 'id\n'
+ 'assetProvider\n'
+ 'assetMediaType\n'
+ 'assetVisibility\n'
+ '}'
+ '}'
+ '}'
+ '}'
+ 'plugin {'
+ `${plugin}`
+ '}'
+ '}';

  const pathWays = 'pathways {'
+ 'id\n'
+ '}\n';

  const walkablePlugin = 'plugin {'
+ `${plugin}`
+ '}\n';

  const activityAncestry = 'ancestry {'
+ 'elementId\n'
+ 'elementType\n'
+ '}\n';

  const interactiveAncestry = 'ancestry {'
+ 'elementId\n'
+ 'elementType\n'
+ '}\n';

  const metaDataFields = 'coursewareMetaInfo(keys:["totalScore"]) {'
+ 'key\n'
+ 'value\n'
+ '}\n';

  const asset = 'assets {'
+ 'edges {'
+ 'node {'
+ 'urn\n'
+ 'source\n'
+ 'metadata\n'
+ 'asset {'
+ 'id\n'
+ 'assetProvider\n'
+ 'assetMediaType\n'
+ 'assetVisibility\n'
+ '}\n'
+ '}\n'
+ '}\n'
+ '}\n';

  const Activity = `${walkableProps}`
+ `${components}`
+ `${pathWays}`
+ `${walkablePlugin}`
+ `${activityAncestry}`
+ `${metaDataFields}`
+ `${asset}`
+ 'config\n'
+ 'theme\n';

  const Interactive = `${walkableProps}`
+ `${components}`
+ `${asset}`
+ `${walkablePlugin}`
+ `${interactiveAncestry}`
+ `${metaDataFields}`
+ 'config';
  const staticDataLessonQuery = (cohortId, deploymentId, lessonId, screenId) => {
    const query = `${'{'
  + ' learn {'
  + ' cohort(cohortId: "'}${cohortId}") {`
  + ` deployment(deploymentId: "${deploymentId}") {`
  + `activity(activityId: "${lessonId}") {`
  + `${Activity}`
  + '}'
  + `interactive(interactiveId: "${screenId}") {`
  + `${Interactive}`
  + '}'
  + '}'
  + '}'
  + '}'
  + '}';
    return query;
  };

  const staticDataCourseWithoutInteractiveQuery = (cohortId, deploymentId, courseId, unitId, lessonId) => {
    const query = `${'{'
      + ' learn {'
      + ' cohort(cohortId: "'}${cohortId}") {`
      + ` deployment(deploymentId: "${deploymentId}") {`
      + `course : activity(activityId: "${courseId}") {`
      + `${Activity}`
      + '}'
      + `unit : activity(activityId: "${unitId}") {`
      + `${Activity}`
      + '}'
      + `activity(activityId: "${lessonId}") {`
      + `${Activity}`
      + '}'
      + '}'
      + '}'
      + '}'
      + '}';
    return query;
  };

  const staticDataFullQuery = (cohortId, deploymentId, courseId, unitId, lessonId, screenId) => {
    const query = `${'{'
      + ' learn {'
      + ' cohort(cohortId: "'}${cohortId}") {`
      + ` deployment(deploymentId: "${deploymentId}") {`
      + `course : activity(activityId: "${courseId}") {`
      + `${Activity}`
      + '}'
      + `unit : activity(activityId: "${unitId}") {`
      + `${Activity}`
      + '}'
      + `activity(activityId: "${lessonId}") {`
      + `${Activity}`
      + '}'
      + `interactive(interactiveId: "${screenId}") {`
      + `${Interactive}`
      + '}'
      + '}'
      + '}'
      + '}'
      + '}';
    return query;
  };
  return {
    staticDataLessonQuery,
    staticDataCourseWithoutInteractiveQuery,
    staticDataFullQuery,
  };
})();
